import { render, staticRenderFns } from "./CareplanInput.vue?vue&type=template&id=70f30fa0&"
import script from "./CareplanInput.vue?vue&type=script&lang=ts&"
export * from "./CareplanInput.vue?vue&type=script&lang=ts&"
import style0 from "./CareplanInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VFileInput,VForm})
